import { render } from "./ContactDesktop.vue?vue&type=template&id=10e6e074&scoped=true"
import script from "./ContactDesktop.vue?vue&type=script&lang=js"
export * from "./ContactDesktop.vue?vue&type=script&lang=js"

import "./ContactDesktop.vue?vue&type=style&index=0&id=10e6e074&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e6e074"]])

export default __exports__